import {useQuery} from "@tanstack/react-query";
import {User} from "../../model/user";
import authRepository from "../../repository/AuthRepository";
import {SiteBunnyError, toSiteBunnyError} from "../../error";

const getData = async () => {
    try {
        const { data } = await authRepository.profile();
        return data.result;
    } catch (e) {
        throw toSiteBunnyError(e);
    }
};

const useLoginUser = (prop?: {useErrorBoundary?: boolean, suspense?: boolean}) => {

    let defaultArguments = {retry: false, suspense: false, useErrorBoundary: false}
    if (prop) {
        defaultArguments = {...defaultArguments, ...prop}
    }

    return useQuery<User, SiteBunnyError>({
        queryKey: ['me'],
        queryFn: async () => getData(),
        ...defaultArguments
    });
};

export default useLoginUser;
